import OnSalePropertiesError from './BricksReservationError';
class ReservationNotFound extends OnSalePropertiesError {
    constructor() {
        super('Bricks reservation does not exist');
    }
}
export default ReservationNotFound;
